import React from 'react';
import PropTypes from 'prop-types';

import AddIcon from '@material-ui/icons/Add';
import Button from '@ublend-npm/aulaui-next-web/Button';

import {
  Container,
  Icon,
  Text,
  GhostButton,
  addGroupToSetButtonClass,
} from './NoContent.styled';

const EmptySet = ({ onNewGroup, onAutoGenerateGroup }) => (
  <Container>
    <Icon>
      <span role="img" aria-label="wind">
        💨
      </span>
    </Icon>
    <Text>
      This set doesn&apos;t currently have any groups. Start by creating them
      below.
    </Text>
    <div>
      <GhostButton type="secondary" size="small" onClick={onAutoGenerateGroup}>
        Auto-generate groups
      </GhostButton>
      <Button
        className={`new-group-button ${addGroupToSetButtonClass}`}
        type="primary"
        size="small"
        iconLeft={AddIcon}
        onClick={onNewGroup}
      >
        Add new group to set
      </Button>
    </div>
  </Container>
);

EmptySet.propTypes = {
  onNewGroup: PropTypes.func.isRequired,
  onAutoGenerateGroup: PropTypes.func.isRequired,
};

export default React.memo(EmptySet);
